import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appDetectTruncation]',
  exportAs: 'appDetectTruncation'
})
export class DetectTruncationDirective implements AfterViewInit, OnDestroy {
  private truncado = false;
  private observadorRedimensionamento?: ResizeObserver;

  constructor(private el: ElementRef) {}

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.atualizarTruncamento();
      if (typeof ResizeObserver !== 'undefined') {
        this.observadorRedimensionamento = new ResizeObserver(() => this.atualizarTruncamento());
        this.observadorRedimensionamento.observe(this.el.nativeElement);
      }
    });
  }

  public ngOnDestroy(): void {
    this.observadorRedimensionamento?.disconnect();
  }

  public isTruncated(): boolean {
    return this.truncado;
  }

  private atualizarTruncamento(): void {
    const element = this.el.nativeElement;
    this.truncado = element.scrollWidth > element.offsetWidth;
  }
}
